import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-cms-login-component',
  templateUrl: './cms-login-component.component.html',
  styleUrls: ['./cms-login-component.component.scss']
})
export class CmsLoginComponentComponent implements OnInit {
    constructor(
        private authService: AuthService,
        private router: Router
    ) { }


    ngOnInit(): void {
        this.authService.isAdmin$.subscribe(val => {
            if(val == true) {
                this.router.navigateByUrl('/cms')
            }
        })
    }

    login() {
        this.authService.login()
    }
}
